// extracted by mini-css-extract-plugin
export default {"markdown":"Markdown_markdown__b0+s0"};